<template>
  <div class="Daily_report">
    <h2>学生信息</h2>
    <el-form style="width: 32%; min-width: 500px" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="学生姓名">
        <el-input v-model="ruleForm.realName" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="学生院所">
        <div class="block">
          <el-input v-model="ruleForm.deptId" :disabled="true"></el-input>
        </div>
      </el-form-item>
      <el-form-item label="学生学号">
        <div class="block">
          <el-input v-model="ruleForm.userIds" :disabled="true"></el-input>
        </div>
      </el-form-item>
      <h2 style="font-size: 20px; margin-left: 20px; padding-bottom: 20px">
        学生可能存在的困扰
      </h2>
      <el-form-item class="difficulty" style="position: relative" label="学习困扰">
        <el-checkbox-group :max="3" v-model="ruleForm.studyDifficulty"  @change="difficulty_other1()">
          <el-checkbox label="1" name="type">学业基础薄弱</el-checkbox>
          <el-checkbox label="2" name="type">学习能力差</el-checkbox>
          <el-checkbox label="3" name="type">科研能力差</el-checkbox>
          <el-checkbox label="4" name="type">缺乏专业兴趣</el-checkbox>
          <el-checkbox label="5" name="type">第一次挂科</el-checkbox>
          <el-checkbox label="6" name="type">多门挂科</el-checkbox>
          <el-checkbox label="7" name="type">缺课缺考</el-checkbox>
          <el-checkbox label="8" name="type">留级延期</el-checkbox>
        </el-checkbox-group>
        <span style="width: 200px;position: absolute;top: 0px;right: 30px;display: block;color: #606266;">其他</span>
        <el-input style="width: 200px; position: absolute; top: 2px; right: -10px" v-model="studyDifficultyOther" placeholder="请输入学习困扰"></el-input>
      </el-form-item>
      <el-form-item class="difficulty" style="position: relative" label="生活困扰">
        <el-checkbox-group :max="3" v-model="ruleForm.lifeDifficulty" @change="difficulty_other2()">
          <el-checkbox label="1" name="type">经济困难</el-checkbox>
          <el-checkbox label="2" name="type">未获助学贷款</el-checkbox>
          <el-checkbox label="3" name="type">家庭重大变故</el-checkbox>
          <el-checkbox label="4" name="type">严重躯体疾病</el-checkbox>
          <el-checkbox label="5" name="type">生活自理困难</el-checkbox>
          <el-checkbox label="6" name="type">身体缺陷</el-checkbox>
          <el-checkbox label="7" name="type">语言困难</el-checkbox>
          <el-checkbox label="8" name="type">被骗被控制</el-checkbox>
        </el-checkbox-group>
        <span style="  width: 200px;  position: absolute;  top: 0px;  right: 0px;  display: block;  color: #606266;">其他</span>
        <el-input style="width: 200px; position: absolute; top: 2px; right: -40px" v-model="lifeDifficultyOther" placeholder="请输入生活困难"></el-input>
      </el-form-item>
      <el-form-item class="difficulty" label="交往困扰" style="position: relative">
        <el-checkbox-group :max="3" v-model="ruleForm.contactDifficulty" @change="difficulty_other3()">
          <el-checkbox label="1" name="type">内向孤僻</el-checkbox>
          <el-checkbox label="2" name="type">退缩回避</el-checkbox>
          <el-checkbox label="3" name="type">适应不良</el-checkbox>
          <el-checkbox label="4" name="type">同学关系不良</el-checkbox>
          <el-checkbox label="5" name="type">师生关系不良</el-checkbox>
          <el-checkbox label="6" name="type">亲密关系不良</el-checkbox>
          <el-checkbox label="7" name="type">家庭关系不良</el-checkbox>
          <el-checkbox label="8" name="type">遭遇欺凌等</el-checkbox>
        </el-checkbox-group>
        <span style="width:200px;position:absolute;top:0px;right:0px;display:block;color: #606266;">其他</span>
        <el-input v-model="contactDifficultyOther" style="width: 200px; position: absolute; top: 2px; right: -40px" placeholder="请输入交往困难"></el-input>
      </el-form-item>
      <el-form-item class="difficulty" label="发展困扰" style="position: relative">

        <el-checkbox-group :max="3" v-model="ruleForm.developDifficulty" @change="difficulty_other4()">
          <el-checkbox label="1" name="type">深感自卑</el-checkbox>
          <el-checkbox label="2" name="type">思想偏激</el-checkbox>
          <el-checkbox label="3" name="type">发展迷茫</el-checkbox>
          <el-checkbox label="4" name="type">过高期待</el-checkbox>
          <el-checkbox label="5" name="type">毕业困难</el-checkbox>
          <el-checkbox label="6" name="type">考研失败</el-checkbox>
          <el-checkbox label="7" name="type">就业困难</el-checkbox>
          <el-checkbox label="8" name="type">创业失败</el-checkbox>
        </el-checkbox-group>

        <span style="width: 200px;position: absolute;top: 0px;right: 130px;display: block;color: #606266;">其他</span>
        <el-input v-model="developDifficultyOther" style="width: 200px; position: absolute; top: 2px; right: 90px" placeholder="请输入发展困难"></el-input>

      </el-form-item>

      <el-form-item class="difficulty" label="心理困扰" style="position: relative">

        <el-checkbox-group :max="3" v-model="ruleForm.psyDifficulty" @change="difficulty_other5()">
          <el-checkbox label="1" name="type">自杀伤人倾向</el-checkbox>
          <el-checkbox label="2" name="type">重性精神病</el-checkbox>
          <el-checkbox label="3" name="type">应激危机</el-checkbox>
          <el-checkbox label="4" name="type">人格问题</el-checkbox>
          <el-checkbox label="5" name="type">情绪障碍</el-checkbox>
          <el-checkbox label="6" name="type">成瘾行为</el-checkbox>
          <el-checkbox label="7" name="type">进食问题</el-checkbox>
          <el-checkbox label="8" name="type">睡眠问题</el-checkbox>
        </el-checkbox-group>
        <span style="width: 200px;position: absolute;top: 0px;right: 80px;display: block;color: #606266;">其他</span>

        <el-input v-model="psyDifficultyOther" style="width: 200px; position: absolute; top: 2px; right: 40px" placeholder="请输入心理困难">
        </el-input>

      </el-form-item>

      <el-form-item label="学生疑似异常情况" prop="difficultDetail">
        <el-input style="height: 100px;width: 250%;" type="textarea" v-model="ruleForm.difficultDetail" placeholder="请填写学生疑似异常的情绪、行为、言语等方面的具体表现，并写明发生的时间地点等信息。如: 23.11.23上午 9点，学生在实验室突然开始哭泣，持续约2小时。同门劝解，但改善不明显。"></el-input>
      </el-form-item>

      <p style="margin-left: 20px;padding-top: 10px;color: #5c5c5c;padding-bottom: 20px;">
        为了方便在需要时联系您，请您在下方留下联系信息
      </p>

      <el-form-item label="预警者姓名" prop="alertName">
        <el-input v-model="ruleForm.alertName"></el-input>
      </el-form-item>

      <el-form-item label="预警者手机号" prop="alertPhone">
        <el-input v-model="ruleForm.alertPhone"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button :loading="ruleFormpd" type="primary" @click="submitForm('ruleForm', 1)">提交</el-button>
        <!-- <el-button @click="resetssForm('ruleForm')">返回</el-button> -->
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      data: [],
      lifeDifficultyOther: "",
      studyDifficultyOther: "",
      contactDifficultyOther: "",
      developDifficultyOther: "",
      psyDifficultyOther: "",
      ruleFormpd: false,
      other1: false,//其他是否显示
      other2: false,//其他是否显示
      other3: false,//其他是否显示
      other4: false,//其他是否显示
      other5: false,//其他是否显示
      ruleForm: {
        realName: "", //学生姓名
        deptId: "", //所属院系
        alertName: "",//预警者姓名
        alertPhone: "",//电话
        difficultDetail: "",//自杀他杀风险详情
        userId: "",//学号
        userIds: "",//学号
        studyDifficulty: [],//学生困难
        lifeDifficulty: [],//生活困难
        contactDifficulty: [],//交往困难
        developDifficulty: [],//发展困难
        psyDifficulty: [],//心理困难
      },
      rules: {
        userId: [
          { required: true, message: "请选择活动区域", trigger: "change" },
        ],
        alertName: [
          { required: true, message: "请输入预警者姓名", trigger: "change" },
        ],
        alertPhone: [
          { required: true, message: "请输入预警者电话", trigger: "change" },
        ],
        difficultDetail: [
          {
            required: true,
            message: "请输入学生疑似异常情况",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    difficulty_other1() {
      for (let i = 0; i <= this.ruleForm.studyDifficulty.length; i++) {
        if (this.ruleForm.studyDifficulty[i] == 9) {
          this.other1 = true;
          return false;
        } else {
          this.other1 = false;
        }
      }
    },
    difficulty_other2() {
      for (let i = 0; i <= this.ruleForm.lifeDifficulty.length; i++) {
        if (this.ruleForm.lifeDifficulty[i] == 9) {
          this.other2 = true;
          return false;
        } else {
          this.other2 = false;
        }
      }
    },
    difficulty_other3() {
      for (let i = 0; i <= this.ruleForm.contactDifficulty.length; i++) {
        if (this.ruleForm.contactDifficulty[i] == 9) {
          this.other3 = true;
          return false;
        } else {
          this.other3 = false;
        }
      }
    },
    difficulty_other4() {
      for (let i = 0; i <= this.ruleForm.developDifficulty.length; i++) {
        if (this.ruleForm.developDifficulty[i] == 9) {
          this.other4 = true;
          return false;
        } else {
          this.other4 = false;
        }
      }
    },
    difficulty_other5() {
      for (let i = 0; i <= this.ruleForm.psyDifficulty.length; i++) {
        if (this.ruleForm.psyDifficulty[i] == 9) {
          this.other5 = true;
          return false;
        } else {
          this.other5 = false;
        }
      }
    },
    resetssForm() {
      this.$router.push("/Crisis/Crisis_addmajor_event");
    },

    submitForm(formName, operate) {
      this.$refs[formName].validate((valid) => {
        //提交按钮
        if (valid) {
          this.ruleForm.studyDifficulty.push(this.studyDifficultyOther);
          this.ruleForm.lifeDifficulty.push(this.lifeDifficultyOther);
          this.ruleForm.contactDifficulty.push(this.contactDifficultyOther);
          this.ruleForm.developDifficulty.push(this.developDifficultyOther);
          this.ruleForm.psyDifficulty.push(this.psyDifficultyOther);
          this.ruleFormpd = true;
          this.$Http_Post("/DistressPrediction/AddDailyCrisis", {
            form: this.ruleForm,
            operate: operate,
            keyNo: this.KeyNo[0],
          }).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.Global.request_successful(res.Message);
            } else {
              this.Global.request_failure(res.Message);
            }
            this.ruleFormpd = false;
            this.ruleForm = this.$options.data().ruleForm;
            this.$refs[formName].resetFields();
          });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  mounted: function () {
    this.KeyNo = [this.$route.query.KeyNo];
    this.$Http_Post("/DistressPrediction/PrefabricatedTableData", {
      keyNo: this.KeyNo[0],
    }).then((res) => {
      if (res.Code == 0) {
        this.ruleForm.userId = res.Data.userId;
        this.ruleForm.realName = res.Data.realName;
        this.ruleForm.alertName = res.Data.alertName;
        this.ruleForm.alertPhone = res.Data.alertPhone;
        this.ruleForm.difficultDetail = res.Data.difficultDetail;
        this.ruleForm = {
          realName: res.Data.realName, // 学生姓名
          deptId: res.Data.deptName, // 所属院系
          alertName: res.Data.alertName, //预警者姓名
          alertPhone: res.Data.alertPhone, //电话
          difficultDetail: res.Data.difficultDetail, // 自杀他杀风险详情
          userIds: res.Data.userId, // 学号s
        };
        for (let i = 0; i <= res.Data.studyDifficultys.length; i++) {
          this.studyDifficultyOther = res.Data.studyDifficultyOther;
          this.ruleForm.studyDifficulty = res.Data.studyDifficultys;
        }
        for (let i = 0; i <= res.Data.lifeDifficultys.length; i++) {
          this.lifeDifficultyOther = res.Data.lifeDifficultyOther;
          this.ruleForm.lifeDifficulty = res.Data.lifeDifficultys;
        }
        for (let i = 0; i <= res.Data.contactDifficultys.length; i++) {
          this.contactDifficultyOther = res.Data.contactDifficultyOther;
          this.ruleForm.contactDifficulty = res.Data.contactDifficultys;
        }
        for (let i = 0; i <= res.Data.developDifficultys.length; i++) {
          this.developDifficultyOther = res.Data.developDifficultyOther;
          this.ruleForm.developDifficulty = res.Data.developDifficultys;
        }
        for (let i = 0; i <= res.Data.psyDifficultys.length; i++) {
          this.psyDifficultyOther = res.Data.psyDifficultyOther;
          this.ruleForm.psyDifficulty = res.Data.psyDifficultys;
        }
      }
    });
  },
};
</script>

<style>
.Daily_report {
  width: 100%;
  height: 100%;
  background-color: #fff;
  overflow: auto;
}
.Daily_report h2 {
  font-size: 20px;
  margin-left: 20px;
  padding-top: 20px;
  line-height: 40px;
}
.Daily_report h6 {
  font-size: 18px;
  margin-left: 20px;
  line-height: 40px;
}
.Daily_report .el-form-item__content {
  margin-left: 160px !important;
}
.Daily_report .el-form-item__label {
  width: 160px !important;
}
.Daily_report .el-textarea__inner {
  height: 100px;
}
.Daily_report .difficulty {
  width: 1400px !important;
}
</style>